import React, { useContext, useState, useEffect, useRef } from 'react';
import { ListingMapContext } from '../../../context/ListingMapContext.js';
import useOutsideClick from '../../../hooks/useOutsideClick.js';
import WindowQuery from '../../../utils/WindowQuery.js';

const STATIC_MAP_TYPES = ['Activities', 'Restaurants', 'Shopping', 'Services'];

export default function TypeDropdown() {
  const updateQuery = new WindowQuery();
  const dropdownRef = useRef();

  const { setDropdown, isTypeIn, setIsTypeIn, categoriesVisible } = useContext(
    ListingMapContext
  );

  const [localMapTypes, setLocalMapTypes] = useState([]);

  useEffect(() => {
    if (isTypeIn) setLocalMapTypes(isTypeIn);
  }, [isTypeIn]);

  useOutsideClick(dropdownRef, categoriesVisible, () => setDropdown(null));

  return (
    <div ref={dropdownRef} className="dropdown-sorting-container">
      <h2 className="dropdown-title">Types</h2>
      <button
        aria-label="Close Dropdown"
        name="Close Dropdown"
        type="button"
        className="mobile-dropdown-cancel btn btn--small"
        onClick={() => {
          setLocalMapTypes([]);
          setDropdown(null);
          updateQuery.remove('is_type_in');
        }}
      >
        Close
      </button>
      <section
        className="dropdown-sorting-inputs"
        style={{ overflowX: 'auto' }}
      >
        {STATIC_MAP_TYPES.map((type, ind) => (
          <label key={ind} htmlFor={`type-type-${type}`}>
            <input
              aria-label={`${type}`}
              id={`type-${type}`}
              type="checkbox"
              checked={localMapTypes.includes(type.toLowerCase())}
              onChange={() => {
                if (localMapTypes.includes(type.toLowerCase())) {
                  const mapTypesCopy = [...localMapTypes];
                  const index = localMapTypes.findIndex(
                    cur => cur === type.toLowerCase()
                  );
                  mapTypesCopy.splice(index, 1);
                  setLocalMapTypes(mapTypesCopy);
                } else {
                  setLocalMapTypes([...localMapTypes, type.toLowerCase()]);
                }
              }}
            />
            <p>{type}</p>
          </label>
        ))}
      </section>
      <section
        className="dropdown-actions"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <button
          aria-label="Apply Category Filters"
          name="Apply Category Filters"
          type="button"
          className="btn btn--dark btn--small"
          onClick={() => {
            updateQuery.add(
              'is_type_in',
              localMapTypes.map(type => type.toLowerCase()).join(',')
            );
            setIsTypeIn(localMapTypes);
            setDropdown(null);
          }}
        >
          Apply
        </button>
        <button
          aria-label="Clear Category Filters"
          name="Clear Category Filters"
          type="button"
          className="btn btn--light btn--small"
          onClick={() => {
            setIsTypeIn([]);
            setLocalMapTypes([]);
            updateQuery.remove('is_type_in');
          }}
        >
          Clear
        </button>
      </section>
    </div>
  );
}
